import React, { Component } from 'react'
import {
    Card, notification, Menu, Breadcrumb,
    PageHeader, Form, Input,
    Cascader, Select, Row, Col, Checkbox,
    Button, AutoComplete, Space
} from 'antd';
// import {PlaceSearch} from '../common/PlaceSearch';
import { withRouter } from 'react-router-dom';
import { getBreeders, createFg } from '../util/APIUtils';
import { withTranslation } from "react-i18next";
import { POLL_LIST_SIZE } from '../constants'
import './FachGroups.css';


const layout = {
    labelCol: {
        span: 8,
    },
    wrapperCol: {
        span: 8,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 8,
        span: 8,
    },
};
const formItemLayout = {
    labelCol: {
        span: 8
    },
    wrapperCol: {
        span: 8
    },
};
const formItemLayoutWithOutLabel = {
    wrapperCol: {
        offset: 8,
        span: 8,
    },
};

class NewFachGroup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            breeders: [],
            isLoading: false,
            visible: false
        };
    }

    loadBreederList() {
        let promise;
        promise = getBreeders();

        if (!promise) {
            return;
        }
        this.setState({ isLoading: true });
        promise.then(response => {
            console.log(response);
            this.setState({
                breeders: response,
                // page: response.page, size: response.size, totalElements:
                // response.totalElements, totalPages: response.totalPages, last: response.last,
                isLoading: false
            })
        }).catch(error => {
            this.setState({ isLoading: false })
        });
    }

    componentDidMount() {
        this.loadBreederList();
    }

    componentDidUpdate(nextProps) {
        if (this.props.isAuthenticated !== nextProps.isAuthenticated) {
            // Reset State
            this.setState({
                breeders: [],
                // page: 0, size: 10, totalElements: 0, totalPages: 0, last: true,
                isLoading: false
            });
            this.loadBreederList();
        }
    }

    handleBack = e => {
        this
            .props
            .history
            .goBack();
    };

    formRef = React.createRef();

    onFinish = (values) => {
        const cropObj = {
            "name": values.name,
            "description": values.description,
            "fachGroupLeaderId": values.fgLeaderId || 0,
        }
        console.log(cropObj);
        createFg(cropObj)
            .then(response => {
                notification.success({
                    message: 'Kultursaat',
                    description: response
                });
                this.props.history.push("/fachgroups");
            }).catch(error => {
                if (error.status === 401) {
                    this.props.handleLogout('/login', 'error', 'You have been logged out.');
                } else {
                    notification.error({
                        message: 'Kultursaat',
                        description: error.message || 'Sorry! Something went wrong. Please try again!'
                    });
                }
            });
    };
    onReset = () => {
        this.formRef.current.resetFields();
    };

    render() {
        const { t } = this.props;
        return (
            <div>
                <PageHeader
                    className="site-page-header"
                    onBack={() => this.handleBack()}
                    title="Neue Fach group"
                    subTitle=""
                    extra={[]
                    }
                />
                <Card bordered={true} loading={this.state.isLoading} >
                    <Form {...layout} ref={this.formRef} name="control-ref" onFinish={this.onFinish}>
                        <Form.Item name="name" label={t("fachgroup.fg_name")} rules={
                            [{ required: true },
                            { min: 2, max: 4, message: 'Username must be between 2 and 4 characters' },
                            { pattern: new RegExp(/^[a-zA-Z]+$/), message: 'Only alphabets.' }
                            ]}>
                            <Input
                                onInput={e => e.target.value = e.target.value.toUpperCase()}
                                validateTrigger="onBlur"
                            />
                        </Form.Item>
                        <Form.Item name="description" label={t("fachgroup.fg_description")} rules={[{ required: true }]}>
                            <Input.TextArea />
                        </Form.Item>
                        <Form.Item name="fgLeaderId" label={t("fachgroup.fg_leader_name")} rules={[{ required: false }]}>
                            <Select >
                                {this.state.breeders.map(fbb =>
                                    <option key={fbb.id} value={fbb.id}>{fbb.firstName + " " + fbb.lastName}</option>
                                )}
                            </Select>
                        </Form.Item>
                        <Form.Item {...tailLayout}>
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                            <Button htmlType="button" onClick={this.onReset}>
                                Reset
                            </Button>
                        </Form.Item>
                    </Form>

                </Card>
            </div>
        )
    }
}

export default withTranslation()(withRouter(NewFachGroup));
